import type { AfDate } from '@Types';

// TODO :: Double check if we are actually going to use the bellow types
interface DATE_NUMBER {
  $numberLong?: string;
}

interface DATE {
  $date?: DATE_NUMBER;
}

interface FILES {
  _id: string;
  created_at?: DATE;
  filename: string;
  path: string;
  type?: string;
  visibility?: string;
  collection: string;
  destinationPath: string;
  icon?: string;
}

interface ICON_MAP {
  [key: string]: string;
}

interface DeleteFile {
  _id: string;
  collection: string;
  destinationPath: string;
  file: string;
  property: string;
  secure: boolean;
}
// TODO :: Double check if we are actually going to use the above types

enum AF_FILE_TYPES {
  BEHAVIOR = 'behavior',
  BITE = 'bite',
  COMMUNITY_SUPPORT_FILE = 'csFile',
  DIAGNOSTIC = 'diagnostic',
  EQUIPMENT_RENTAL = 'equipment_rental',
  EXAM = 'exam',
  EXAMS = 'exams',
  FIELD_SERVICE_CITATION = 'fSCitation',
  FIELD_SERVICE_FILE = 'fSFile',
  FOSTER = 'foster',
  GENERAL = 'general',
  MEDICATION = 'medication',
  OUTCOMES = 'outcome',
  PARTNERS = 'partners',
  PEOPLE = 'people',
  PROCEDURE = 'procedure',
  SURGERY = 'surgery',
  TNVR = 'tnvr',
  TRANSPORT = 'transport',
  VACCINATION = 'vaccination',
}

enum AF_FILE_COLLECTIONS {
  ANIMALS = 'animals',
  BITES = 'bites',
  COMMUNITY_SUPPORT_CALLS = 'communitySupportCalls',
  FIELD_SERVICE_CALLS = 'fieldServicesCalls',
  INTAKES = 'intakes',
  MEDICAL_BEHAVIOR = 'behaviorRecords',
  MEDICAL_DIAGNOSTIC = 'medicalDiagnostics',
  MEDICAL_EXAM = 'medicalRecords',
  MEDICAL_MEDICATION = 'medicalMedications',
  MEDICAL_PROCEDURE = 'procedures',
  MEDICAL_SURGERY = 'medicalSurgeries',
  MEDICAL_VACCINATION = 'medicalVaccinations',
  OUTCOMES_COLLECTION = 'outcomes',
  PARTNERS_COLLECTION = 'partners',
  PEOPLE_COLLECTION = 'people',
  TNVR_CALLS = 'tnvrCalls',
  TRANSPORT_CALLS = 'transports',
}

enum AF_FILE_ICON {
  CSV = 'csv',
  DOC = 'doc',
  DOCX = 'docx',
  GIF = 'gif',
  JPEG = 'jpeg',
  JPG = 'jpg',
  PDF = 'pdf',
  PNG = 'png',
  TXT = 'txt',
  WEBP = 'webp',
  XLS = 'xls',
  XLSX = 'xlsx',
}

enum AF_FILE_PROPERTY {
  CITATIONS = 'citations',
  FILES = 'files',
}

type AfFileIcon = `${AF_FILE_ICON}`;
type AfFileProperty = `${AF_FILE_PROPERTY}`;
type AfFileType = `${AF_FILE_TYPES}`;
type AfFileCollection = `${AF_FILE_COLLECTIONS}`;
interface AfFile {
  _id: string;
  collection?: AfFileCollection;
  created_at: AfDate;
  destinationPath?: string;
  disableLink?: boolean;
  fileTypeId?: string;
  filename: string;
  rabies: boolean;
  spay_neuter: boolean;
  icon: AfFileIcon;
  path: string;
  type: AfFileType;
  visibility: 'public' | 'private';
  status: 'active' | 'hidden' | 'deleted';
}

export type { AfFile, AF_FILE_ICON, AfFileCollection, AfFileProperty, AfFileType, DeleteFile, FILES, ICON_MAP };
export { AF_FILE_COLLECTIONS, AF_FILE_TYPES, AF_FILE_PROPERTY };
